// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const apartamentoService = async (aptoId: number) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/apto/${aptoId}`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
